import { Delegate } from "vendor";
import { __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod, Modal } from "theme";

let _CustomisationModal_instances, _onAfterShowListener, onAfterShow_fn, _onAfterHideListener, onAfterHide_fn, _onLocationChangeListener, onLocationChange_fn, _onColourChangeListener, onColourChange_fn, _onFontChangeListener, onFontChange_fn, _onTextChangeListener, onTextChange_fn, _onResizeListener, onResize_fn;
let CustomisationModal = class extends Modal {
	constructor() {
		super();
	    __privateAdd(this, _CustomisationModal_instances);
		__privateAdd(this, _onAfterShowListener, __privateMethod(this, _CustomisationModal_instances, onAfterShow_fn).bind(this));
	    __privateAdd(this, _onAfterHideListener, __privateMethod(this, _CustomisationModal_instances, onAfterHide_fn).bind(this));
		__privateAdd(this, _onLocationChangeListener, __privateMethod(this, _CustomisationModal_instances, onLocationChange_fn).bind(this));
	    __privateAdd(this, _onColourChangeListener, __privateMethod(this, _CustomisationModal_instances, onColourChange_fn).bind(this));
		__privateAdd(this, _onFontChangeListener, __privateMethod(this, _CustomisationModal_instances, onFontChange_fn).bind(this));
		__privateAdd(this, _onTextChangeListener, __privateMethod(this, _CustomisationModal_instances, onTextChange_fn).bind(this));
		__privateAdd(this, _onResizeListener, __privateMethod(this, _CustomisationModal_instances, onResize_fn).bind(this));
	}
	
    connectedCallback() {
		super.connectedCallback();
	    this.addEventListener("dialog:after-show", __privateGet(this, _onAfterShowListener));
		this.addEventListener("dialog:after-hide", __privateGet(this, _onAfterHideListener));
		this.locationSelector.addEventListener("change", __privateGet(this, _onLocationChangeListener));
		this.fontSelectors.forEach((input) => {
			input.addEventListener("change", __privateGet(this, _onFontChangeListener));
		});

		this.colourSelectors.forEach((input) => {
			input.addEventListener("change", __privateGet(this, _onColourChangeListener));
		});
		this.textSelector.addEventListener("change", __privateGet(this, _onTextChangeListener));
		this.textSelector.addEventListener("keyup", __privateGet(this, _onTextChangeListener));
		window.addEventListener("resize", __privateGet(this, _onResizeListener));
		this.updateLocationData();
		this.updateColourData();
		this.updateFontData();
		this.flexFont();
    }
	
    disconnectedCallback() {
	    this.removeEventListener("dialog:after-show", __privateGet(this, _onAfterShowListener));
		this.removeEventListener("dialog:after-hide", __privateGet(this, _onAfterHideListener));
		this.locationSelector.removeEventListener("change", __privateGet(this, _onLocationChangeListener));
		this.fontSelectors.forEach((input) => {
			input.removeEventListener("change", __privateGet(this, _onFontChangeListener));
		});
		this.colourSelectors.forEach((input) => {
			input.removeEventListener("change", __privateGet(this, _onColourChangeListener));
		});
		this.textSelector.removeEventListener("change", __privateGet(this, _onTextChangeListener));
		this.textSelector.removeEventListener("keyup", __privateGet(this, _onTextChangeListener));
		window.removeEventListener("resize", __privateGet(this, _onResizeListener));
    }
	
    get colourSelectors() {
      return this.querySelectorAll('[name="properties[Thread Colour]"]');
    }
	
    get selectedColour() {
      return this.querySelector('[name="properties[Thread Colour]"]:checked')
    }
	
    get fontSelectors() {
      return this.querySelectorAll('[name="properties[Personalised Font]"]');
    }
	
    get selectedFont() {
      return this.querySelector('[name="properties[Personalised Font]"]:checked')
    }
	
    get locationSelector() {
      return this.querySelector('[name="properties[Personalised Location]"]');
    }
	
    get selectedlocation() {
      return this.querySelector('[name="properties[Personalised Location]"]').querySelector('option:checked');
    }
	
    get textSelector() {
      return this.querySelector('[name="properties[Embroidery Text]"]');
    }
	
    get customiserPreview() {
      return this.querySelector('.customiser-preview');
    }
	
    get customiserGallery() {
      return this.querySelector('.customiser-gallery');
    }
	
	getSiblings(element, filter) {
		var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
		var siblings = [];
		var currentElement = element; // Do the previous first

		while (currentElement = currentElement.previousElementSibling) {
			if (!filter || currentElement.matches(filter)) {
				siblings.push(currentElement);
			}
		}

		if (includeSelf) {
			siblings.push(element);
		} // Then the next side


		currentElement = element;

		while (currentElement = currentElement.nextElementSibling) {
			if (!filter || currentElement.matches(filter)) {
				siblings.push(currentElement);
			}
		}

		return siblings;
	}
	
	updateLocationData() {
		let media_item = this.querySelector('#' + this.selectedlocation.dataset.mediaId);
	
		media_item.removeAttribute('hidden');
	    this.getSiblings(media_item, ':not(.customiser-preview)').forEach(function (sibling_media_item) {
			return sibling_media_item.setAttribute('hidden', 'hidden');
	    });
	
		this.customiserPreview.style.top = media_item.dataset.positionY + '%';
		this.customiserPreview.style.left = media_item.dataset.positionX + '%';
		this.customiserPreview.style.fontSize = media_item.dataset.fontSize + '%';
		
		if (media_item.dataset.textAlign == 'Left') {
			this.customiserPreview.style.transform = 'translate(0,-50%)';
		} else if (media_item.dataset.textAlign == 'Right') {
			this.customiserPreview.style.transform = 'translate(-100%,-50%)';
		} else {
			this.customiserPreview.style.transform = 'translate(-50%,-50%)';
		}
	}
	
	updateColourData() {
		this.customiserPreview.style.color = this.selectedColour.dataset.hexCode;
	}
	
	updateFontData() {
		this.customiserPreview.style.fontFamily = this.selectedFont.value;
	}
	
	updateTextData(event) {
		let custom_styles = '';
		if (event.target.value.length <= 2) {
			custom_styles = ' style="font-size: 150%;"'
		}
		
		this.customiserPreview.innerHTML = '<span' + custom_styles + '">' + event.target.value + '</span>';
	}
	
	flexFont() {
	  	let relative_font_factor = this.customiserGallery.offsetWidth * 0.1;
	    this.customiserGallery.style.fontSize = relative_font_factor + 'px';
	}
};

_CustomisationModal_instances = new WeakSet();

_onAfterShowListener = new WeakMap();
onAfterShow_fn = function() {
    Array.from(this.querySelectorAll("input, select")).forEach((input) => {
    	input.removeAttribute('disabled');
    });
};

_onAfterHideListener = new WeakMap();
onAfterHide_fn = function() {
    Array.from(this.querySelectorAll("input, select")).forEach((input) => {
    	input.setAttribute('disabled', true);
    });
};

_onLocationChangeListener = new WeakMap();
onLocationChange_fn = function() {
	this.updateLocationData();
};

_onFontChangeListener = new WeakMap();
onFontChange_fn = function() {
	this.updateFontData();
};

_onColourChangeListener = new WeakMap();
onColourChange_fn = function() {
	this.updateColourData();
};

_onTextChangeListener = new WeakMap();
onTextChange_fn = function(event) {
	this.updateTextData(event);
};

_onResizeListener = new WeakMap();
onResize_fn = function() {
	this.flexFont();
};

if (!window.customElements.get("customisation-modal")) {
  window.customElements.define("customisation-modal", CustomisationModal);
}

export {
	CustomisationModal
};

